import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import auth from './auth';
import bills from './bills';
import devices from './devices';
import infoEvents from './infoEvents';
import contracts from './contracts';
import statistics from './statistics';
import rides from './rides';
import dashboard from './dashboard';
import modal from './modal';
import settings from './settings';
import langs from './lang';
import geozones from './geozones';
import { autocatalog } from './autocatalog';

const rootReducer = combineReducers({
  routing: routerReducer,
  auth,
  devices,
  infoEvents,
  contracts,
  statistics,
  rides,
  dashboard,
  modal,
  settings,
  bills,
  langs,
  geozones,
  autocatalog
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js